import Backgrounds from "./Backgrounds";

export default Backgrounds;
